"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketSelector = void 0;
exports.default = MarketSelectorWrap;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _componentUtilities = require("@ux/component-utilities");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _link = _interopRequireDefault(require("@ux/link"));
var _columnLayout = require("@ux/column-layout");
var _trayMenu = require("@ux/tray-menu");
var _util = require("@ux/util");
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _world = _interopRequireDefault(require("@ux/icon/world"));
var _mapPin = _interopRequireDefault(require("@ux/icon/map-pin"));
require("@ux/tray-menu/styles");
require("@ux/column-layout/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Market selector component.
 *
 * This renders an anchor with the label showing the current market. When it is
 * clicked it will open up a tray dropdown with all the available markets.
 * Clicking on them will then fire of a transfer to the market website.
 *
 * @class Columns
 * @public
 */
class MarketSelector extends _react.Component {
  constructor() {
    super(...arguments);
    this.onTrayToggle = this.onTrayToggle.bind(this);
    this.lockScroll = this.lockScroll.bind(this);
    this.unlockScroll = this.unlockScroll.bind(this);
  }

  /**
   * Return the label for a market.
   * Ex: en-US becomes "United States - English"
   *
   * @param {String} name market
   * @returns {String} Label for the specified market
   * @private
   */
  getMarketLabel(name) {
    if (!this.props.marketData) {
      return name;
    }
    const marketInfo = this.props.marketData[name];
    if (!marketInfo) {
      return;
    }
    return `${marketInfo.countryName} - ${marketInfo.languageName}`;
  }

  /**
   * Return the market for the aria-label.
   * Ex: en-US becomes "United States - English"
   *
   * @param {String} name market
   * @returns {String} Label for the specified market
   * @private
   */
  getMarketDescription(name) {
    if (!this.props.marketData) {
      return name;
    }
    const marketInfo = this.props.marketData[name];
    if (!marketInfo) {
      return 'Unknown market';
    }
    return marketInfo.description;
  }

  /**
   * If we are on a mobile breakpoint, then invoke the handlers to potentially
   * lock or unlock scrolling for the `document.body`.
   *
   * @param  {Boolean} open Value indicating if the TrayMenu in this Component is open.
   */
  onTrayToggle(open) {
    if (!(0, _componentUtilities.isMobile)(this.props.breakpoint)) {
      return;
    }
    if (open) {
      this.lockScroll();
    }
    if (!open) {
      this.unlockScroll();
    }
  }

  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */
  lockScroll() {
    //
    // Add className to the target to indicate that the TrayMenu is open.
    // This className ensures that the correct scroll bars are added when we
    // have content that is overflowing.
    //
    if (this.props.lockScrollOnOpen) {
      const target = document.body;
      target.classList.add('market-selector-open');
    }
  }

  /**
   * Add a class to set `overflow: hidden;`  on `document.body`.
   * This prevents scrolling of background content.
   *
   * TODO: Apply the Mobile Safari fix for GX-4564 when complete.
   */
  unlockScroll() {
    //
    // Remove className to the target to indicate that the TrayMenu is closed.
    //
    const target = document.body;
    target.classList.remove('market-selector-open');
  }

  /**
   * Render the markets into columns.
   *
   * @returns {Array} markets Array of ColumnItems
   * @private
   */
  renderMarkets() {
    const {
      manifest,
      eidPrefix,
      currentMarket,
      currentPage = '',
      urls = {},
      urlArgs,
      marketData,
      isReseller
    } = this.props;
    const marketNames = this.props.markets;
    let markets = [];
    if (marketData && marketNames) {
      markets = marketNames.reduce((acc, marketName) => {
        const marketDataForMarket = marketData[marketName];
        if (marketDataForMarket) acc.push(marketDataForMarket);
        return acc;
      }, []);
    }
    urls.markets = urls.markets || {};
    urls.pcgo = urls.pcgo || {};

    //
    // All links to change market must go through GUI (the service urls.pcgo points to).
    // The GUI service sets the `market` cookie before redirecting to the `currentPage`.
    //
    const redirect = new _util.URL(urls.pcgo.href, true);
    redirect.set('pathname', `${redirect.pathname}/${currentPage}`);
    return markets.reduce((acc, market) => {
      const marketName = market.market || '';
      const eid = (0, _golfToEid.default)(`:${marketName.replace(/-/g, '_')}`, {
        prefix: `${eidPrefix}.${(0, _golfToEid.default)(manifest)}.market_selector`,
        postfix: 'click'
      });
      const ariaLabelMarket = market.countryName + ', ' + market.languageName;
      let url = urls.markets[marketName] || '#';
      if (typeof url === 'string') {
        url = {
          href: url
        };
      }

      // During client re-render in reseller sales header, include explicit
      // target parameter specifying current location.
      if (typeof document !== 'undefined' && isReseller) {
        url = new _util.URL(url.href, true);
        url.set('query', _objectSpread(_objectSpread({}, url.query), {}, {
          target: window.location.href
        }));
        url = {
          href: url.href
        };
      }
      if (market) {
        redirect.set('query', _objectSpread(_objectSpread({}, redirect.query), {}, {
          regionsite: market.countrySite,
          marketid: market.market
        }));
        acc.push( /*#__PURE__*/_react.default.createElement(_columnLayout.ColumnItem, {
          key: marketName,
          isSelected: marketName === currentMarket
        }, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({}, url, {
          "data-tcc-ignore": true,
          urlArgs: urlArgs,
          redirect: isReseller ? null : redirect.href,
          "data-market": marketName,
          "data-eid": eid,
          "aria-label": ariaLabelMarket
        }), /*#__PURE__*/_react.default.createElement("span", {
          "data-tcc-ignore": true
        }, /*#__PURE__*/_react.default.createElement("strong", {
          "data-tcc-ignore": true
        }, market.countryName), " - ", market.languageName, /*#__PURE__*/_react.default.createElement("span", {
          className: "market-location"
        }, /*#__PURE__*/_react.default.createElement(_mapPin.default, {
          height: 14,
          width: 14
        }))))));
      }
      return acc;
    }, []);
  }

  /**
   * Get the two-letter short language code for the specified market
   * e.g. en-US: EN, el-GR: EL, fr-CA: FR
   *
   * If a displayCode is returned from the Markets API, use that instead.
   *
   * @param {String} market The market name to parse (e.g. en-US, el-GR, fr-CA)
   * @returns {String} The language code of the specified market, in upper case
   * @private
   */
  getShortLanguageCode(market) {
    if (!market || typeof market !== 'string') return '';
    const marketInfo = this.props.marketData && this.props.marketData[market];
    const displayCode = marketInfo && marketInfo.displayCode;
    if (displayCode) {
      return displayCode;
    }
    const marketParts = market.split('-');
    return marketParts[0].toUpperCase();
  }

  /**
   * Generate the tray title to show
   *
   * @returns {ReactElement} The title node to show for the tray
   * @private
   */
  getTrayName() {
    const {
      currentMarket,
      compact
    } = this.props;
    const currentMarketName = this.getMarketLabel(currentMarket) || 'Unknown market';
    let label = currentMarketName;
    if (compact) {
      label = this.getShortLanguageCode(currentMarket);
    }
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "mrkt-selector-tray-name",
      title: currentMarketName
    }, /*#__PURE__*/_react.default.createElement(_world.default, null), /*#__PURE__*/_react.default.createElement("span", {
      className: "mrkt-selector-tray-label"
    }, label));
  }

  /**
   * Render the component.
   *
   * @returns {ReactElement} TrayMenu
   * @api public
   */
  render() {
    const {
      numColumns,
      messages,
      currentMarket,
      eidPrefix,
      manifest
    } = this.props;
    const eid = (0, _golfToEid.default)('market_selector', {
      prefix: `${eidPrefix}.${(0, _golfToEid.default)(manifest)}`,
      postfix: 'click'
    });
    const marketDescription = this.getMarketDescription(currentMarket);
    if (this.trayMenu) {
      const isOpen = this.trayMenu.state.open;
      if ((0, _componentUtilities.isMobile)(this.props.breakpoint) && isOpen) {
        this.lockScroll();
      } else if ((0, _componentUtilities.isMobile)(this.props.breakpoint) && !isOpen || !(0, _componentUtilities.isMobile)(this.props.breakpoint) && isOpen) {
        this.unlockScroll();
      }
    }
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: currentMarket,
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:MarketSelectorTray:AriaLabel",
      values: {
        selection: marketDescription
      }
    }, content => /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      ariaLabel: content.selection,
      type: "base"
      // eslint-disable-line no-return-assign
      ,
      ref: c => this.trayMenu = c,
      name: this.getTrayName(),
      className: "market-selector",
      onToggle: this.onTrayToggle,
      "data-eid": eid
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-wrap"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-flex market-selector-content"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:MarketSelectorTray:Title"
    })), /*#__PURE__*/_react.default.createElement(_columnLayout.Columns, {
      num: numColumns,
      style: "vertical",
      className: "market-list"
    }, this.renderMarkets()))))));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
exports.MarketSelector = MarketSelector;
MarketSelector.propTypes = {
  manifest: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  currentPage: _propTypes.default.string,
  currentMarket: _propTypes.default.string.isRequired,
  intl: _propTypes.default.object,
  numColumns: _propTypes.default.number,
  markets: _propTypes.default.array,
  urls: _propTypes.default.object.isRequired,
  urlArgs: _propTypes.default.object,
  messages: _propTypes.default.object.isRequired,
  compact: _propTypes.default.bool,
  open: _propTypes.default.bool,
  lockScrollOnOpen: _propTypes.default.bool,
  marketData: _propTypes.default.object,
  isReseller: _propTypes.default.bool,
  breakpoint: _propTypes.default.string
};

/**
 * Default property values.
 *
 * @type {Object}
 * @public
 */
MarketSelector.defaultProps = {
  manifest: 'SalesHeader',
  eidPrefix: 'uxp.hyd',
  currentMarket: 'en-US',
  numColumns: 4,
  urlArgs: {},
  compact: false,
  open: false,
  lockScrollOnOpen: false,
  marketData: {}
};
function MarketSelectorWrap(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)('mobile', 'phablet', 'tablet', 'desktop', 'large');
  return /*#__PURE__*/_react.default.createElement(MarketSelector, (0, _extends2.default)({}, props, {
    breakpoint: breakpoint
  }));
}
MarketSelectorWrap.propTypes = {};